import script from "./Advertising.vue?vue&type=script&setup=true&lang=ts"
export * from "./Advertising.vue?vue&type=script&setup=true&lang=ts"

import "./Advertising.vue?vue&type=style&index=0&id=3e407934&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e407934"]])

export default __exports__